import { rem } from "@huub-web/utils/css/rem";
import { recipe } from "@vanilla-extract/recipes";

import { responsiveContainer } from "../../utils/responsive";
import { transition } from "../../utils/transition";
import { headingStyle } from "../Heading/Heading.css";

export const iconContainerStyle = recipe({
  base: {
    position: "relative",
    fontSize: 0,
  },
  variants: {
    hasHover: {
      true: {},
    },
  },
});

export const iconActionStyle = recipe({
  base: {
    position: "absolute",
    bottom: rem(-6),
    left: rem(-6),
    padding: rem(2),
    borderRadius: "50%",
    backgroundColor: "var(--background)",
    transition: transition("background"),
  },
  variants: {
    hasHover: {
      true: {
        opacity: 1,
      },
    },
  },
});

export const buttonStyle = recipe({
  base: {},
  variants: {
    variant: {
      button: {
        selectors: {
          [`${headingStyle} &`]: {
            display: "none",
            ...responsiveContainer({
              500: {
                display: "inline-flex",
              },
            }),
          },
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      } as any,
      iconButton: {
        display: "none",
        selectors: {
          [`${headingStyle} &`]: {
            display: "inline-flex",
            ...responsiveContainer({
              500: {
                display: "none",
              },
            }),
          },
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      } as any,
    },
  },
});
